<template src="./template.html"></template>
<style src="./styles.scss" lang="scss"></style>

<script>
 import { mapActions, mapState } from 'vuex'
 import { isEmpty } from 'lodash'

 export default {
   name: 'LanguageChanger',
   props: {
     type: {
       type: String,
       default: 'list',
     },
   },
   data() {
     return {
       menu: false,
     }
   },
   computed: {
     ...mapState('auth', ['settings']),
     ...mapState('translations', { availableLanguages: 'languages' }),
     getLanguageKey() {
       return this.$i18n.locale.replace(/-/g, '_')
     },
   },
   created() {
     if (isEmpty(this.availableLanguages)) {
       this.getAvailableLanguages()
     }
   },
   methods: {
     ...mapActions('translations', ['getAvailableLanguages']),
     changeLocale(key) {
       if (this.getLanguageKey === key) return
       this.$router.push('/' + key)
     },
     getLanguageName(key = null) {
       key = key || this.getLanguageKey
       const language = key.split('_')[0]
       const languageNames = new Intl.DisplayNames([ language ], { type: 'language' })
       return languageNames.of(language)
     },
   },
 }
</script>
